<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jII6U9/tc-custom/9781454933007.jpg?1729082748673" alt="This image is the cover for the book Science Book, Union Square & Co. Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Science Book, Union Square & Co. Milestones
      </h1>
      <p class="bookDescription body article font2">
        <b>From astronomy to psychology, this comprehensive and fully illustrated volume presents the most groundbreaking milestones in the history of science. </b><br/><br/> <br/><br/>Science author Cliff Pickover continues his award–winning series—which includes <i>The Math Book</i>, <i>The Physics Book, </i>and<i> The Medical Book</i>—by gathering the most important thinkers and ideas in the history of science into one gorgeously illustrated volume.<br/><br/>This unique omnibus edition includes 250 thoughtfully selected entries from many of the science-based books in the Sterling Milestones series, including math, physics, medicine, biology, chemistry, engineering, psychology, and space. With a new introduction by Pickover explaining how this impressive collection was curated, <i>The Science Book</i> showcases humanity’s greatest achievements and provides readers with a sense of wonder at the diversity of scientific discovery.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clifford A. Pickover
      </h2>
      
      <p class="authorDescription body article">Clifford A. Pickover, a research staff member at IBM&rsquo;s T. J. Watson Research Center, is an authority on the interface of science, art, mathematics, computing, and the visual modeling of data. He is the author of such highly regarded books as <I>Black Holes: A Traveler&rsquo;s Guide</I>, <I>The Alien IQ Test</I>, and <I>Chaos in Wonderland: Visual Adventures in a Fractal World</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f24bc60a